import React, { useState } from 'react';
import { Container, Button, Card, Row, Col, Image, Modal } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';

const MatchDayInfo: React.FC = () => {
  const [showImageModal, setShowImageModal] = useState(false);

  const handleCloseImageModal = () => setShowImageModal(false);
  const handleShowImageModal = () => setShowImageModal(true);

  return (
    <>
      <Helmet>
          <title>Ashridge Park FC | Grassroots Football Club in Wokingham</title>
          <meta name="description" content="Welcome to Ashridge Park FC, a charter standard community football club in Wokingham, Berkshire, offering youth and adult football for all ages." />
      </Helmet>
      <Container className="p-3 my-4">
        <h2 className="mb-4">MATCH DAY INFO</h2>
        
        {/* Section 1: Document Download with Image Preview */}
        <Card className="mb-5">
          <Card.Body>
            <Row className="align-items-center">
              {/* Left Column: Text and Button */}
              <Col md={8}>
                <Card.Title>Ashridge Fixture Template Document</Card.Title>
                <Card.Text>
                  Download the official fixture template for the season by clicking the button or the preview image.
                </Card.Text>
                <Button 
                  as="a"
                  variant="outline-primary" 
                  href="/content/2025-26-Fixture-Notification-Template.docx" 
                  download
                >
                  Download Fixture Template (.docx)
                </Button>
              </Col>
              {/* Right Column: Clickable Image */}
              <Col md={4} className="text-center">
                <a href="/content/2025-26-Fixture-Notification-Template.docx" download>
                  <Image 
                    src="/content/fixture-template-preview.png" 
                    alt="Fixture template preview"
                    fluid 
                    rounded 
                    className="shadow-sm"
                    style={{ cursor: 'pointer' }}
                  />
                </a>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Section 2: Map and Pitch Layout */}
        <Row className="align-items-start">
          
          {/* Google Map Column */}
          <Col lg={7} className="mb-4">
            <h3 className="mb-3">Our Home Ground: St Crispins School</h3>
            <div className="ratio ratio-16x9 shadow-sm" style={{ borderRadius: '15px' }}>
              <iframe 
                src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJkSI5Hz-BdkgRwB8TdzYEPAM&key=AIzaSyANv2W59WYEoo-8kTOmBAwVTOlu4NS3dDU"
                style={{ border: 0, borderRadius: '15px' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="crispins"
              ></iframe>
            </div>
          </Col>

          {/* Pitch Layout Image Column */}
          <Col lg={5} className="mb-4">
            <h3 className="mb-3">Pitches & Amenities</h3>
            <Image 
              src="/content/Ashridge Park - Pitches and Amenities-large.png" 
              alt="Ashridge Park pitch and amenities layout"
              fluid 
              rounded 
              className="shadow-sm"
              onClick={handleShowImageModal}
              style={{ cursor: 'pointer' }}
            />
          </Col>

        </Row>
      </Container>

      {/* Image Lightbox Modal */}
      <Modal show={showImageModal} onHide={handleCloseImageModal} size="xl" centered>
        <Modal.Body className="p-0">
          <Image 
            src="/content/Ashridge Park - Pitches and Amenities-large.png" 
            alt="Ashridge Park pitch and amenities layout"
            fluid 
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MatchDayInfo;